import { render, staticRenderFns } from "./DetailsRawData.vue?vue&type=template&id=5e13373f&scoped=true"
import script from "./DetailsRawData.vue?vue&type=script&lang=js"
export * from "./DetailsRawData.vue?vue&type=script&lang=js"
import style0 from "./DetailsRawData.vue?vue&type=style&index=0&id=5e13373f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13373f",
  null
  
)

export default component.exports